module.exports = __webpack_public_path__ + "img/com_TNO.9c966063.png";